import { ButtonProps, FormInstance, SwitchProps } from "antd";
import {
  DataCols,
  DataColumn,
  DataColumnField,
  DataColumnRecord,
  DataElement,
  DataInputCommonParams,
  DataInputElement,
  dateFormatterEx,
  DisplayCondition,
  ElementProps,
  InputVariant,
  RadarProps,
} from "../input/inputType";
import { cn } from "@/lib/utils";
import { CSSProperties, MouseEventHandler, RefObject, ReactNode } from "react";
import type { PartialTheme as NivoTheme } from "@nivo/theming";
import {
  convertTempFtoC,
  copyFormValue,
  defaultFloatFomatter,
  GetDataInputElement,
  GetUnitElement,
  runFormFunction,
} from "../input/inputFunction";
// import { Datum } from "@nivo/line";
import { AlertProps, TransitionType } from "../layoutType";
import { Debug } from "@/util/debug";

import Icon from "@/components/common/icon/icon";
import { enLocale, koLocale } from "@/i18n/routing";
import { LineSeries } from "@nivo/line";
import { fetchHost } from "@/util/fetchutil";
import { AppPostData, appRouterPush, isNativePlatform } from "@/util/apputil";
import { checkEmpty } from "@/util/stringutil";
import { DefaultOptionType } from "antd/es/select";
import { SvgFillMatcher } from "@nivo/core";
import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });
const dv = require("@datas/default.json");
export const siteUrl = dv.siteUrl;
export const input_direct = dv.input_direct;
export const fetchOption = dv.fetchOption;
export const fetchPostOption = dv.fetchPostOption;
export const setTimeoutDelay: number = dv.setTimeoutDelay;
export const setTimeoutShort: number = dv.setTimeoutShort;
export const tooltipColor: string = dv.tooltipColor;
export const viewVariant: InputVariant = "borderless";
// export const brewingDetail = "brewing_detail";
// export const brewingDetailClassName = " " + brewingDetail;
export const defaultAllowClear = true; //{ clearIcon: <Icon iconType="" iconName="Eraser" size="20" className="-m-1" /> };
export const mobileHidden = "hidden md:flex";
export const mobileShow = "md:invisible";
export const inputCalcWidth = "w-[6rem] md:w-[7rem]";
export const selectYearWidth = "w-[5.5rem]";
export const inputAuthWidth = "w-[5.5rem]";
export const inputNumberWidth = "w-[6rem] md:w-[7rem]";
export const inputNumberWithButtonWidth = "w-[3.5rem] md:w-[4.5rem]";
export const inputSelectWidth = "min-w-[7rem]";
export const searchSelectWidth = "min-w-[8rem]";
export const greenbeanMinMaxWidth = "w-[8rem]";
export const textLastClassName = " text-last";
export const inputCalcClassName = inputCalcWidth + textLastClassName;
export const inputNumberClassName = inputNumberWidth + textLastClassName;
export const boldClassName = "font-bold";
export const strongLabelClassName = boldClassName + " text-amber-800";
export const roastingTimeWidth = "w-[7rem] md:w-[8rem]";
export const roastingTimeButtonWidth = "w-[4.5rem] md:w-[5.5rem]";
export const inputCountryClassName = "min-w-[16rem] ";
export const roastingProfileClassName = "roasting_profile_item";
export const roastingCheckItemClassName = "roasting_check_item";
export const compareItemClassName = "compare_item";
export const greenbeanSeqWidth = "w-full max-w-[calc(94vw-5.5rem)] MobileUnderLine";
export const greenbeanNumberWidth = "w-[5.5rem]";
export const greenbeanMassWidth = "w-[6.5rem]";
export const brewingTimer = "brewing_start_time";
export const settingDetail = "setting_detail";
export const settingEspresso = "setting_espresso";

export const getButtonProp = (iconName: string, className?: string, iconType?: string): ButtonProps => {
  return {
    type: "link",
    className: cn(className),
    icon: <Icon iconName={iconName} iconType={iconType ?? ""} weight="bold" size="20" />,
  };
};
export const getStepMarks = (
  step?: number | string[] | number[],
  min?: number,
  max?: number,
  unitPrev?: DataInputElement | string,
  unit?: DataInputElement | string,
): Record<string | number, ReactNode> => {
  const result: Record<string | number, ReactNode> = {};
  const unitObj = unit ? (GetDataInputElement(unit, true, null) ?? "") : "";
  const unitPrevObj = unitPrev ? (GetDataInputElement(unitPrev, true, null) ?? "") : "";
  if (step) {
    if (typeof step == "number") {
      if (min !== undefined && max !== undefined) {
        result[min] = GetUnitElement(min, unitPrevObj, unitObj);
        result[max] = GetUnitElement(max, unitPrevObj, unitObj);
        let nowstep = min + step;
        while (nowstep <= max) {
          result[step] = GetUnitElement(nowstep, unitPrevObj, unitObj);
          nowstep += step;
        }
      } else {
        result[step] = GetUnitElement(step, unitPrevObj, unitObj);
      }
    } else if (step instanceof Array) {
      step.forEach((item) => {
        result[item] = GetUnitElement(item, unitPrevObj, unitObj);
      });
    } else {
      result[step] = GetUnitElement(step, unitPrevObj, unitObj);
    }
  } else {
    if (typeof min == "number" && typeof max == "number") {
      result[min] = GetUnitElement(min, unitPrevObj, unitObj);
      result[max] = GetUnitElement(max, unitPrevObj, unitObj);
      const center = min + (min + max) / 2;
      result[center] = GetUnitElement(center, unitPrevObj, unitObj);
    }
  }
  return result;
};
export const disabled = (props: DataColumnField): DataColumnField => {
  return { ...props, disabled: true };
};
export const nivoTheme: NivoTheme = {
  text: { fill: "var(--gray-a11)" },
  tooltip: { container: { background: "var(--color-background)" } },
  legends: { text: { fontSize: 16, fontWeight: "bold" } },
};
export const minButton: ButtonProps = getButtonProp("CoffeeBean", "opacity-50 mt-[2px]");
export const maxButton = getButtonProp("CoffeeBean", "mt-[2px]");
export const buttonMinMax = { minButton, maxButton };
export const switchText: SwitchProps = { checkedChildren: "enable", unCheckedChildren: "disable" };
export const switchIcon: SwitchProps = {
  checkedChildren: <Icon iconName="Circle" iconType="" weight="bold" />,
  unCheckedChildren: <Icon iconName="X" iconType="" weight="bold" />,
};

export const seqClassName = (field: string): DataColumn => {
  return { field: field, className: "w-[5rem] text-center", label: "seq_label" };
};

export const radarInputCommon: DataInputCommonParams = {
  labelUse: true,
  asChild: false,
  readInput: true,
  defaultValue: 10,
};
export const radarProp: RadarProps = {
  //frontInput: true,
  commonInputProp: radarInputCommon,
  rotation: -30,
  margin: { top: 70, right: 40, bottom: 40, left: 40 },
  className: "flex-col h-[22rem] w-full max-w-[40rem] mt-[1rem]",
  legends: [
    {
      // data: [{ id: "point", label: "test" }],
      anchor: "top-left",
      direction: "column",
      itemWidth: 480,
      itemHeight: 40,
      itemTextColor: "var(--accent-indicator)",
      translateX: -20,
      translateY: -70,

      symbolSize: 16,
      symbolShape: "circle",
      effects: [
        {
          on: "hover",
          style: {
            itemTextColor: "var(--gray-12)",
          },
        },
      ],
    },
  ],
};
export const timelineInputCommon: DataInputCommonParams = {
  labelUse: true,
  asChild: false,
  readInput: true,
  defaultValue: 10,
};

export const radar: DataColumnField = { inputType: "radar", labelUse: false, maxValue: 10, step: 1, minValue: 0 };
export const radarRate: DataColumnField = { ...radar, inputType: "radarRate", radarProp: radarProp };
export const radarSlider: DataColumnField = {
  ...radar,
  inputType: "radarSlider",
  radarProp: {
    ...radarProp,
    commonInputProp: {
      ...radarInputCommon,
      sliderProp: { marks: { ...getStepMarks(0, 10) } },
      inputClassName: "max-w-[120px] w-full",
      inputNumberClassName: "ml-2 max-h-[2rem]",
    },
  },
};
export const radarRateR: DataColumnField = {
  ...radarRate,
  radarProp: { ...radarRate.radarProp, curve: "catmullRomClosed", gridShape: "circular" },
};
export const radarSliderR: DataColumnField = {
  ...radarSlider,
  radarProp: { ...radarSlider.radarProp, curve: "catmullRomClosed", gridShape: "circular" },
};
export const cupRadar: DataColumnField = {
  ...radarRate,
  fieldList: [
    {
      cupnote_balance_point: "Balance",
      cupnote_aroma_point: "Aroma",
      cupnote_sweetness_point: "Sweetness",
      cupnote_body_point: "Body",
      cupnote_flavor_point: "Flavor",
      cupnote_acidity_point: "Acidity",
    },
  ],
};

export const lineChart: DataColumnField = {
  inputType: "lineChart",
  labelUse: false,
  timelineProp: {
    className: "flex-col h-[15rem] md:h-[22rem] lg:h-[30rem] w-full",
    commonInputProp: {
      ...timelineInputCommon,
    },
  },
};
export const timelineChart: DataColumnField = {
  inputType: "timelineChart",
  //labelTransition: false,
  labelUse: false,
  timelineProp: {
    className: "flex-col h-[15rem] md:h-[22rem] lg:h-[30rem] w-full",
    commonInputProp: {
      ...timelineInputCommon,
    },
  },
};
export const geoMapChart: DataColumnField = {
  inputType: "geoMap",
  imageDownload: "Map",
  labelUse: false,
  geoMapProp: {
    className: "flex-col h-[15rem] md:h-[22rem] lg:h-[30rem] w-full",
    mapDisplay: false,
  },
};
export const geoMapCountryChart = (indexKey: string | string[], readDisplay?: DisplayCondition): DataColumnField => {
  return {
    ...geoMapChart,
    read: {
      display: readDisplay,
      disabled: true,
      // geoMapProp: { ...dc.geoMapChart.geoMapProp, emptyElement: { element: "select_country_open_map" } },
    },
    indexKey: indexKey,
  };
};
export const geoMapCountryList = (
  formFunction: Record<string, Record<string, Function>> | undefined,
  geoMapId: string,
  locale?: string,
  readDisplay?: boolean,
): DataColumnField => {
  return {
    ...country,
    noItem: false,
    readInput: true,
    readInputDisabled: true,
    label: "country_label",
    inputType: "selectSearch",
    selectProp: { mode: "multiple" },
    read: {
      labelNext: {
        element: locale === koLocale ? "GlobeHemisphereEast" : "GlobeHemisphereWest",
        elementType: "icon",
        className: "m-1 cursor-pointer",
        tooltip: "country_tooltip_hint",
        iconProp: { iconName: "", iconType: "Info", weight: "bold" },
      },
      display: readDisplay ? "notNull" : undefined,
      disabled: true,
      onClick: (e) => {
        const target = !checkEmpty(e.target.dataset) ? e.target : e.target.querySelector("[data-value]");
        if (target) {
          Debug(target);
          const key = target.dataset.value;
          // const label = target.innerText;
          // const country: Record<string, string> = {};
          if (key !== undefined) {
            Debug("setKey", key);
            // country[key] = label;
            runFormFunction(formFunction, geoMapId, "setSelectCountry", [key]);
          } else {
            Debug(target, key);
          }
        }
      },
    },
  };
};
export const flavorWheel: DataColumnField = {
  inputType: "flavorWheel",
  labelUse: false,
};

export const hidden: DataColumnField = { inputType: "input", disabled: true, itemClassName: "hidden" };
export const itemDiv: DataColumnField = { label: "blank", inputType: "display", itemClassName: "itemDiv", saveData: false };

export const seq: DataColumnField = { valueType: "number", disabled: true, read: { disabled: false }, label: "seq_label" };
export const number: DataColumnField = { valueType: "number", type: "number" };
export const link: DataColumnField = { inputType: "link", readInput: false };
export const storeLink: DataColumnField = {
  ...link,
  copyProp: { copyButton: true },
  linkPropOption: { newTab: true },
  minLength: 3,
  maxLength: 500,
  showCount: true,
  read: { display: "notNull" },
};
export const inputFull: DataColumnField = { inputType: "input" };
export const input: DataColumnField = { ...inputFull, inputClassName: "max-w-[370px]" };
export const inputSearch: DataColumnField = { inputType: "inputSearch" };
export const textAreaU: DataColumnField = {
  inputType: "textArea",
  maxLength: undefined,
  showCount: false,
  textAreaProp: { rows: 8 },
  textAreaResize: true,
};
export const textArea: DataColumnField = {
  inputType: "textArea",
  labelClassName: "md:my-auto",
  read: { display: "notNull", variant: "borderless", textAreaAutoSize: true },
  edit: { showCount: true, valueClassName: "mb-4", labelClassName: "md:my-auto pb-4", textAreaResize: false, textAreaProp: { rows: 4 } },
  maxLength: 1000,
};
export const textAreaDefault: DataColumnField = { ...textArea, label: "desc_label" };
export const textAreaM: DataColumnField = { ...textArea, edit: { ...textArea.edit, textAreaProp: { rows: 10 } }, maxLength: 3000 };
export const textAreaMDefault: DataColumnField = { ...textAreaM, label: "desc_label" };
export const password: DataColumnField = { ...input, password: true };
export const use: DataColumnField = { inputType: "switch", defaultValue: true, read: { inputClassName: "ml-2" } };
export const useOX: DataColumnField = { ...use, switchProp: { checkedChildren: "O", unCheckedChildren: "X" } };
export const useIcon: DataColumnField = { ...use, switchProp: switchIcon };
export const useText: DataColumnField = { ...use, transition: true, switchProp: switchText };
export const useTextStr = (checked: string, unchecked?: string, transition?: boolean): DataColumnField => {
  return { ...use, transition: transition ?? true, switchProp: { checkedChildren: checked, unCheckedChildren: unchecked ?? checked } };
};
export const useDefault: DataColumnField = { ...use, label: "use_label" };
export const year: DataColumnField = { inputType: "year" };
export const yearDefaultValue: DataColumnField = { inputType: "year", defaultValue: new Date() };
export const seqYear: DataColumnField = { ...year, label: "seqyear_label" };
export const quarter: DataColumnField = { inputType: "quarter" };
export const month: DataColumnField = { inputType: "month" };
export const monthSelectFn = (locale?: string): DataColumnField => {
  return {
    inputType: "select",
    inputClassName: "min-w-[120px]",
    valueList:
      locale === koLocale
        ? [
            { value: 1, label: "1월" },
            { value: 2, label: "2월" },
            { value: 3, label: "3월" },
            { value: 4, label: "4월" },
            { value: 5, label: "5월" },
            { value: 6, label: "6월" },
            { value: 7, label: "7월" },
            { value: 8, label: "8월" },
            { value: 9, label: "9월" },
            { value: 10, label: "10월" },
            { value: 11, label: "11월" },
            { value: 12, label: "12월" },
          ]
        : [
            { value: 1, label: "January" },
            { value: 2, label: "February" },
            { value: 3, label: "March" },
            { value: 4, label: "April" },
            { value: 5, label: "May" },
            { value: 6, label: "June" },
            { value: 7, label: "July" },
            { value: 8, label: "August" },
            { value: 9, label: "September" },
            { value: 10, label: "October" },
            { value: 11, label: "November" },
            { value: 12, label: "December" },
          ],
  };
};
export const monthSelect: DataColumnField = {
  inputType: "select",
  inputClassName: "min-w-[120px]",
  valueList: [
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5" },
    { value: 6, label: "6" },
    { value: 7, label: "7" },
    { value: 8, label: "8" },
    { value: 9, label: "9" },
    { value: 10, label: "10" },
    { value: 11, label: "11" },
    { value: 12, label: "12" },
  ],
};

export const week: DataColumnField = { inputType: "week" };
export const date: DataColumnField = { inputType: "date" };
export const datetime: DataColumnField = { inputType: "datetime" };
export const time: DataColumnField = { inputType: "time" };
export const timer: DataColumnField = { inputType: "time", timeProp: { showHour: false, showNow: false }, dateFormatter: "mm:ss" };
export const hourTimer: DataColumnField = { inputType: "time", timeProp: { showNow: false }, dateFormatter: "HH:mm:ss" };
export const secondTimer = (locale?: string): DataColumnField => {
  return {
    inputType: "time",
    timeProp: { showHour: false, showNow: false },
    dateFormatter:
      locale !== koLocale
        ? {
            hour: "H[h] m[m] s[s]",
            hourzZ: "H[h] m[m]",
            hourZz: "H[h] s[s]",
            hourZZ: "H[h]",
            minute: "m[m] s[s]",
            minuteZ: "m[m]",
            second: "s[s]",
          }
        : {
            hour: "H시간 m분 s초",
            hourzZ: "H시간 m분",
            hourZz: "HH시간 s초",
            hourZZ: "HH시간",
            minute: "m분 s초",
            minuteZ: "m분",
            second: "s초",
          },
  };
};
export const getSecondTimerFormat = (locale?: string, space?: string): dateFormatterEx => {
  const space_str = space ?? " ";
  return locale !== koLocale
    ? {
        hour: "H[h]" + space_str + "m[m]" + space_str + "s[s]",
        hourzZ: "H[h]" + space_str + "m[m]",
        hourZz: "H[h]" + space_str + "s[s]",
        hourZZ: "H[h]",
        minute: "m[m]" + space_str + "s[s]",
        minuteZ: "m[m]",
        second: "s[s]",
      }
    : {
        hour: "H시간" + space_str + "m분" + space_str + "s초",
        hourzZ: "H시간" + space_str + "m분",
        hourZz: "HH시간" + space_str + "s초",
        hourZZ: "HH시간",
        minute: "m분" + space_str + "s초",
        minuteZ: "m분",
        second: "s초",
      };
};
export const defaultListColDescProp: DataColumnField = {
  inputType: "switchButton",
  itemClassName: "mr-auto",
  transition: true,
  switchProp: { checkedChildren: "summary_label", unCheckedChildren: "summary_label" },
  switchButtonProp: { checkedChildren: { type: "primary" }, unCheckedChildren: {}, buttonName: "Note" },
};

export const qrcode: DataColumnField = {
  inputType: "qrcode",
  label: "qrcode_label",
  qrProp: { size: 120, uselink: true, download: { buttonClassName: "w-[120px]" }, bgColor: "white" },
  edit: { display: false },
  linkPropOption: { newTab: false, linkButtonFront: true, text: " ", linkButtonTitleTooltip: false, linkButtonIcon: false },
  copyProp: { copyButton: true, copyButtonFront: true, copyButtonTitleTooltip: false, copyButtonIcon: false },
  readInput: false,
};
export const select: DataColumnField = { inputType: "select", inputClassName: "min-w-[120px]" };
export const selectTag: DataColumnField = { ...select, selectProp: { mode: "tags", tokenSeparators: [","] } };
export const selectMulti: DataColumnField = { ...select, selectProp: { mode: "multiple" } };
export const selectSearch: DataColumnField = { inputType: "selectSearch" };
export const selectSearchTag: DataColumnField = { inputType: "selectSearch", selectProp: { mode: "tags", tokenSeparators: [","] } };
export const selectSearchMulti: DataColumnField = {
  inputType: "selectSearch",
  selectProp: {
    mode: "multiple",
    // tagRender: (props) => {
    //   Debug(props);
    //   return <span>{props.label}</span>;
    // },
  },
};
export const listUseLabel = [
  { value: 1, label: "yes_label" },
  { value: 0, label: "no_label" },
  { value: undefined, label: "blank" },
  { value: null, label: "blank" },
];
export const listSearchUseLabel: DefaultOptionType[] = [
  { value: 1, label: "O" },
  { value: 0, label: "X" },
];

export const listUse = { ...select, transition: true, valueList: listUseLabel };

export const listSearchUse = {
  ...select,
  valueList: [{ value: "", label: "All" }, ...listSearchUseLabel],
};
export const eventStatus: DataColumnField = {
  ...select,
  valueList: [
    { value: -1, label: "before_label" },
    { value: 0, label: "progress_label" },
    { value: 1, label: "complete_label" },
  ],
  transition: true,
};
export const image: DataColumnField = { inputType: "image" };
export const rate: DataColumnField = { inputType: "rate" };
export const rateDefault: DataColumnField = {
  inputType: "rate",
  read: { variant: "borderless" },
  inputClassName: "mt-2",
  inputNumberClassName: "max-w-[4rem] ml-2",
  maxValue: 10,
  minValue: 0,
  formatter: defaultFloatFomatter,
};
export const rateInput: DataColumnField = {
  ...rateDefault,
  inputType: "rateInput",
};
export const rateInputLast: DataColumnField = {
  ...rateInput,
  inputNumberClassName: rateInput.inputNumberClassName + " text-last",
};

export const slider: DataColumnField = { inputType: "slider", inputClassName: "max-w-[120px] w-full" };
export const sliderInput: DataColumnField = {
  inputType: "sliderInput",
  read: { variant: "borderless" },
  inputClassName: "max-w-[120px] w-full",
  inputNumberClassName: "ml-2 max-h-[2rem]",
};
export const clickDefault: Function = (click?: Function, noInfo?: Function) => {
  return (e: any) => {
    if (e.target) {
      const target = e.target as HTMLSpanElement;
      if (target.dataset.value) {
        Debug(target.dataset.value);
        if (click) {
          click(target.dataset.value);
        }
      } else if (noInfo) {
        noInfo();
      }
    }
  };
};
export const passwordDisabled: DataColumnField = { ...password, readOnly: true };

export const numberDisabled: DataColumnField = { ...number, disabled: true };
export const inputDisabled: DataColumnField = { ...input, disabled: true };
export const inputFullDisabled: DataColumnField = { ...inputFull, disabled: true };
export const labelHidden: DataColumnField = { labelUse: false, valueStyle: { gridColumn: "1 / span 2" } };
export const useDisabled: DataColumnField = { ...use, disabled: true };
export const useOXDisabled: DataColumnField = { ...useOX, disabled: true };
export const useIconDisabled: DataColumnField = { ...useIcon, disabled: true };
export const useTextDisabled: DataColumnField = { ...useText, disabled: true };
export const useDefaultDisabled: DataColumnField = { ...useDefault, disabled: true };
export const yearDisabled: DataColumnField = { ...year, disabled: true };
export const quarterDisabled: DataColumnField = { ...quarter, disabled: true };
export const monthDisabled: DataColumnField = { ...month, disabled: true };
export const weekDisabled: DataColumnField = { ...week, disabled: true };
export const dateDisabled: DataColumnField = { ...date, disabled: true };
export const timeDisabled: DataColumnField = { ...time, disabled: true };
export const datetimeDisabled: DataColumnField = { ...datetime, disabled: true };
export const selectDisabled: DataColumnField = { ...select, disabled: true };
export const selectSearchDisabled: DataColumnField = { ...selectSearch, disabled: true };
export const dayNumber: DataColumnField = {
  ...number,
  inputClassName: "text-last",
  unitPrev: "+",
  unit: { element: "day_unit", transition: true },
};
export const at: DataColumnField = {
  inputType: "datetime",
  disabled: true,
  timeProp: { nowButton: false },
  read: { variant: "borderless" },
}; //, read: { variant: "borderless" }
export const by: DataColumnField = {
  inputType: "inputNumber",
  valueType: "number",
  disabled: true,
  display: "notNull",
  read: { variant: "borderless" },
};
export const display_user: DataColumnField = { ...inputDisabled, widthFull: false, read: { variant: "borderless" } };
export const by_admin: DataColumnField = { ...by, checkUserType: ["SADMIN"] };
export const display_user_admin: DataColumnField = { ...display_user, checkUserType: ["SADMIN"] };
export const rgst: DataColumnField = {
  fieldId: { rgst_user: display_user, rgst_by: by, rgst_at: { ...at, placeholder: "rgst_at" } },
  create: { display: false },
};
export const edit: DataColumnField = {
  fieldId: { edit_user: display_user, edit_by: by, edit_at: { ...at, placeholder: "edit_at" } },
  create: { display: false },
};
export const rgst_admin: DataColumnField = {
  fieldId: { rgst_user: display_user_admin, rgst_by: by_admin, rgst_at: { ...at, placeholder: "rgst_at" } },
  create: { display: false },
};
export const edit_admin: DataColumnField = {
  fieldId: { edit_user: display_user_admin, edit_by: by_admin, edit_at: { ...at, placeholder: "edit_at" } },
  create: { display: false },
};
export const number1f: DataColumnField = { ...number, scale: 10, step: 0.1 };
export const number2f: DataColumnField = { ...number, scale: 100, step: 0.01 };
export const roastingInputDefault: DataColumnField = {
  ...number2f,
  placeholder: "input",
  formatter: defaultFloatFomatter,
  nextInputHidden: true,
  inputClassName: "text-last",
  read: { display: "notNull", displayCheckIds: [] },
};
// export const roastingInput1: DataColumnField = { ...roastingInputDefault, inputClassName: "hidden md:block text-last" };
// export const roastingInput2: DataColumnField = { ...roastingInputDefault, placeholder: "input2" };
// export const roastingInput3: DataColumnField = { ...roastingInputDefault, placeholder: "input3" };

export const roastingInput1: DataColumnField = { ...roastingInputDefault }; //, inputClassName: "hidden md:block text-last" };
export const roastingInput2: DataColumnField = { ...roastingInputDefault, placeholder: "input2" };
export const roastingInput3: DataColumnField = { ...roastingInputDefault, placeholder: "input3" };

export const percent: DataColumnField = {
  valueType: "number",
  type: "number",
  scale: 10,
  step: 0.1,
  unit: "%",
  inputClassName: inputNumberClassName,
  minValue: 0,
  maxValue: 100,
};
export const temp: DataColumnField = {
  valueType: "number",
  type: "number",
  scale: 100,
  step: 0.1,
  unit: "°C",
  //unitProp: { unitList: ["°C", "°F"] },
  placeholder: "temperature",
  inputClassName: inputNumberClassName,
};
export const mass: DataColumnField = {
  valueType: "number",
  type: "number",
  scale: 10,
  step: 0.1,
  unit: "g",
  //unitProp: { unitList: ["g", "Kg", "t", "oz", "lb"] },
  placeholder: "mass",
  formatter: defaultFloatFomatter,
  inputClassName: inputNumberClassName,
};
export const untilMinite: DataColumnField = {
  valueType: "number",
  type: "number",
  scale: 1,
  step: 1,
  unit: { element: "until_minute", transition: true },
  //unitProp: { unitList: ["g", "Kg", "t", "oz", "lb"] },
  formatter: defaultFloatFomatter,
  inputClassName: inputNumberClassName,
};

export const moisture: DataColumnField = {
  ...percent,
  placeholder: "moisture",
};

export const density: DataColumnField = {
  valueType: "number",
  type: "number",
  scale: 10,
  step: 0.1,
  unit: "g/L",
  placeholder: "density",
  maxValue: 2000,
};
export const lossRate: DataColumnField = {
  ...percent,
  formatter: defaultFloatFomatter,
  step: 0.1,
  placeholder: "loss_rate",
};
export const hum: DataColumnField = { ...percent, placeholder: "hum" };
export const hPa: DataColumnField = {
  valueType: "number",
  type: "number",
  scale: 10,
  step: 0.1,
  unit: "hPa",
  formatter: defaultFloatFomatter,
  inputClassName: "w-[8rem] text-last",
  placeholder: "hPa",
};
export const bar: DataColumnField = {
  valueType: "number",
  type: "number",
  scale: 10,
  step: 0.1,
  unit: "bar",
  formatter: defaultFloatFomatter,
  inputClassName: inputNumberClassName,
  placeholder: "bar",
};
export const distance: DataColumnField = {
  valueType: "number",
  type: "number",
  scale: 10,
  step: 0.1,
  unit: "m",
  formatter: defaultFloatFomatter,
  inputClassName: "w-[8rem] text-last",
  placeholder: "distance",
};
export const distanceM: DataColumnField = {
  valueType: "number",
  type: "number",
  unit: "m",
  formatter: defaultFloatFomatter,
  inputClassName: "w-[8rem] text-last",
  placeholder: "distance",
};
export const altitude: DataColumnField = {
  ...distanceM,
  placeholder: "altitude",
};
export const weatherButton = (form: RefObject<FormInstance<any> | undefined> | undefined, barometer?: string): DataElement | string => {
  return {
    element: "outside",
    elementType: "button",
    transition: true,
    buttonProp: {
      onClick: async (e: any) => {
        try {
          const position = await fetch("https://ipapi.co/json/");
          if (!position.ok) throw new Error("네트워크 오류: " + position.status);
          const position_data = await position.json(); // JSON 변환
          const fetch_option = { ...dv.fetchOption };
          fetch_option.body = JSON.stringify({
            lat: position_data.latitude,
            lon: position_data.longitude,
            units: "metric",
          });
          fetchHost("/api/userWeather", fetch_option, undefined, (data: any) => {
            Debug(data);
            const weather_data = data.result; //await weather.json(); // JSON 변환
            const temp = Math.round(weather_data.main.temp * 10) / 10;
            const humidity = weather_data.main.humidity;
            const pressure = weather_data.main.pressure;
            const setValues = { outside_air: temp, outside_hum: humidity, outside_hpa: pressure };
            Debug(weather_data, setValues);
            form?.current?.setFieldsValue(setValues);
          });
          if (isNativePlatform) {
            if (barometer) {
              AppPostData({ dataType: "getAppData", key: barometer, value: "Barometer", valueType: "number" });
            }
          }
        } catch (e) {
          Debug(e);
        }
      },
    },
  };
  // return isNativePlatform ? {} : "outside";
};
export const waterHard: DataColumnField = { ...number, inputClassName: inputNumberClassName, unit: "ppm", placeholder: "water_hard" };
export const waterAlk: DataColumnField = { ...number, inputClassName: inputNumberClassName, unit: "ppm", placeholder: "water_alk" };
export const waterTds: DataColumnField = { ...number, inputClassName: inputNumberClassName, unit: "ppm", placeholder: "water_tds" };
export const count: DataColumnField = {
  ...number1f,
  inputClassName: inputNumberClassName,
  step: 1,
  unit: { element: "count_number", transition: true },
};
export const mm: DataColumnField = { ...number, inputClassName: inputNumberClassName, unit: "mm" };
export const brewingMass: DataColumnField = {
  ...mass,
  step: 0.1,
  noItem: false,
  hiddenCheckValue: true,
  placeholder: "input_mass",
  variant: "outlined",
  inputClassName: inputNumberClassName + " with_pick",
};
export const brewingMassCalc: DataColumnField = {
  ...mass,
  noItem: false,
  disabled: true,
  readOnly: true,
  variant: "outlined",
  placeholder: "",
  inputClassName: inputCalcClassName + " view-disabled with_pick",
  //emptyUnit: false,
};
export const brewingStepTimer: DataColumnField = {
  ...timer,
  variant: "outlined",
  inputClassName: roastingTimeWidth,
  indexKey: "brewing_start_time",
  hiddenCheckValue: true,
  noItem: false,
};
export const brewingBar: DataColumnField = { ...bar, placeholder: "brewing_bar" };
export const brewingFlux: DataColumnField = { ...mass, unit: "g/s", placeholder: "brewing_flux" };
export const publicType: DataColumnField = {
  ...select,
  inputClassName: inputAuthWidth,
  codeGroup: "PBTP",
  create: { defaultValue: "NONE" },
  // display: false,
  read: { display: "notNull", inputClassName: inputAuthWidth + " text-center" },
};
export const publicUUID = (pathname: string): DataColumnField => {
  return {
    ...qrcode,
    display: ["notNull", { public_type: { value: ["NONE", null], equals: false } }],
    linkOption: { pathname },
  };
};
export const cafeAuth: DataColumnField = {
  ...select,
  codeGroup: "CAUTH",
  selectFilter: ["OWN", "SMNG", "MNG", "SAST", "BARISTA"],
};
export const roasterAuth: DataColumnField = {
  ...select,
  codeGroup: "RAUTH",
  selectFilter: ["OWN", "SMNG", "MNG", "SAST", "ROASTER"],
};
export const country: DataColumnField = {
  ...selectSearch,
  inputClassName: inputCountryClassName,
  codeGroup: "CNTR",
};
export const coffee_country: DataColumnField = {
  ...country,
  codeGroup: "CNTR",
  selectFilter: "CFPRDC",
};
export const coffee_country_feat: DataColumnField = {
  ...coffee_country,
  codeGroupLabel: "feat",
};
export const variety: DataColumnField = {
  ...selectSearch,
  codeGroup: "VRT",
  label: "variety_label",
  inputClassName: inputCountryClassName,
};
export const varietyFeat: DataColumnField = {
  ...variety,
  codeGroupLabel: "feat",
};

export const varietyMulti: DataColumnField = {
  ...variety,
  ...selectSearchMulti,
};
export const varietyMultiFeat: DataColumnField = {
  ...varietyMulti,
  codeGroupLabel: "feat",
};

export const process: DataColumnField = {
  ...selectSearch,
  codeGroup: "PRCS",
  label: "process_label",
  inputClassName: inputCountryClassName,
};
export const processFeat: DataColumnField = {
  ...process,
  codeGroupLabel: "feat",
};
export const grade: DataColumnField = {
  ...selectSearch,
  label: "grade_label",
  codeGroup: "BGRD",
  inputClassName: inputCountryClassName,
};
export const gradeFeat: DataColumnField = {
  ...grade,
  codeGroupLabel: "feat",
};
export const gradeDetail: DataColumnField = {
  ...selectSearch,
  label: "grade_detail_label",
  codeGroup: "BQLT",
  inputClassName: inputCountryClassName,
};
export const gradeDetailFeat: DataColumnField = {
  ...gradeDetail,
  codeGroupLabel: "feat",
};

export const airTemp: DataColumnField = {
  ...temp,
  formatter: defaultFloatFomatter,
  inputClassName: temp.inputClassName + " " + inputNumberWidth,
  placeholder: "air_temp",
};
export const roastingTemp: DataColumnField = {
  ...airTemp,
  minValue: 0,
  maxValue: 300,
  placeholder: "coffee_temp",
};
export const roastingAir: DataColumnField = {
  ...temp,
  formatter: defaultFloatFomatter,
  inputClassName: temp.inputClassName + " w-[6.5rem]",
  placeholder: "air_temp",
};
export const roastingSlideTemp: DataColumnField = {
  ...roastingTemp,
  inputType: "sliderInput",
  inputClassName: "ml-2 max-w-[20rem] w-full",
  inputNumberClassName: "ml-6 w-[6.5rem] max-h-[2rem] text-last",
  sliderProp: { marks: getStepMarks([70, 150, 190, 220, 250], 0, 250, undefined, temp.unit) },
};
export const roastingTime: DataColumnField = {
  ...datetime,
  inputClassName: roastingTimeWidth,
  tooltip: true,
  scrollMargin: "div.data-chart.TimelineChart",
};
export const roastingTerm: DataColumnField = {
  ...timer,
  inputClassName: roastingTimeWidth,
  read: { placeholder: "" },
  scrollMargin: "div.data-chart.TimelineChart",
};
export const agtron: DataColumnField = {
  valueType: "number",
  type: "number",
  inputClassName: "w-[8rem]",
  unitPrev: "#",
  minValue: 20,
  maxValue: 99,
  step: 0.1,
  scale: 10,
  placeholder: "agtron",
};

export const selectCountry: DataColumnField = {
  ...selectSearch,
  label: "country_label",
  inputClassName: inputCountryClassName,
  codeGroup: "CNTR",
  selectPropOption: { reloadButton: true },
};
export type AuthDataType = "cafe" | "roaster" | "user";
export const equipSelect = (authDataType: AuthDataType | "info", locale?: string): DataColumnField => {
  return {
    ...select,
    dataUrl: authDataType === "info" ? undefined : "/api/" + authDataType + "/item/equip/code",
    dataValueList: authDataType === "info" ? "info_equip_list" : undefined,
    dataLabel: {
      value: authDataType + "_equip_seq",
      label: [
        locale === enLocale ? { field: "equip_nick", subs: "equip_name" } : { field: "equip_nick_locale", subs: "equip_name_locale" },
      ],
      labelSort: true,
    },
    read: { display: "notNull" },
  };
};
export const brewingSelect = (locale: string | undefined, multi?: boolean): DataColumnField => {
  return {
    ...selectSearch,
    selectProp: {
      mode: multi ? "multiple" : undefined,
      maxCount: 10,
    },
    selectPropOption: { multiValueNumber: true },
    inputClassName: greenbeanSeqWidth,
    widthFull: true,
    tooltip: multi ? false : true,
    tooltipTransition: false,
    tooltipPlacement: "topLeft",
    dataLabel: {
      value: "brewing_seq",
      label: [locale === enLocale ? "brewing_name" : "brewing_name_locale"],
      labelSort: true,
    },
  };
};
export const buttonDefault = (
  iconName: string,
  onClick: MouseEventHandler<HTMLElement> | undefined,
  buttonType?: "link" | "text" | "default" | "primary" | "dashed",
  innerTitle?: string,
  className?: string,
  iconType?: string,
  iconFront?: boolean,
  disabled?: boolean,
): DataColumnField => {
  return {
    inputType: "element",
    elementProp: buttonElement(onClick, iconName, buttonType, innerTitle, className, iconType, iconFront, disabled),
  };
};
export const buttonElement = (
  onClick: MouseEventHandler<HTMLElement> | undefined,
  iconName?: string,
  buttonType?: "link" | "text" | "default" | "primary" | "dashed",
  innerTitle?: string,
  className?: string,
  iconType?: string,
  iconFront?: boolean,
  disabled?: boolean,
  transition?: boolean,
): ElementProps => {
  const element = !iconName && innerTitle ? innerTitle : <Icon iconType={iconType ?? ""} iconName={iconName ?? ""} />;
  const fixValue = typeof element !== "string" && innerTitle ? innerTitle : undefined;
  return {
    element,
    elementType: "button",
    fixValue: fixValue,
    buttonProp: {
      type: buttonType ?? "default",
      className: className ?? (fixValue ? "" : "px-2"),
      onClick: onClick,
      disabled,
    },
    iconFront,
    transition,
  };
};
export const textButton = (iconName: string, text: string, onClick: MouseEventHandler<HTMLElement>, className?: string) => {
  return buttonDefault(iconName, onClick, "default", text, className ?? "ml-2");
};
export const iconButton = (
  iconName: string,
  onClick: MouseEventHandler<HTMLElement> | undefined,
  tooltip?: string,
  className?: string,
): DataColumnField => {
  return {
    ...buttonDefault(iconName, onClick, "default", undefined, className ?? "ml-2 px-2"),
    tooltip: tooltip,
  };
};

export const copyButton = (
  form: FormInstance | undefined,
  t: TransitionType | undefined,
  ta: TransitionType | undefined,
  iconName: string,
  field: string,
): DataColumnField => {
  return {
    ...buttonDefault(
      iconName,
      () => {
        copyFormValue(form, field, t, ta);
      },
      "default",
      undefined,
      "ml-2 px-2",
    ),
    tooltip: field,
  };
};
export const labelLinkButton = (
  router: AppRouterInstance,
  link: string,
  title?: string,
  transintion?: boolean,
  iconName?: string,
  iconFront?: boolean,
): DataElement | string => {
  return buttonElement(
    () => {
      appRouterPush(router, link);
    },
    iconName,
    "text",
    title,
    strongLabelClassName,
    undefined,
    undefined,
    iconFront,
    transintion ?? true,
  );
};
export const introTitle: DataColumnField = {
  label: "blank",
  labelClassName: mobileHidden,
  valueClassName: strongLabelClassName,
  inputType: "display",
  transition: true,
};
export const introDefault: DataColumnField = {
  inputType: "display",
  labelClassName: boldClassName,
  valueClassName: "whitespace-pre-wrap my-auto",
  saveData: false,
  variant: "borderless",
  edit: { showCount: false },
  readOnly: true,
  transition: true,
};
export const introLink: DataColumnField = {
  ...link,
  label: "blank",
  labelClassName: mobileHidden,
  linkOption: { useEncode: false },
  linkPropOption: { title: "link_text", linkButtonUse: false },
  dataInputMode: "view",
  readOnly: true,
  saveData: false,
};
export const guideDefault: DataColumnField = {
  inputType: "display",
  label: "blank",
  itemClassName: "font-bold whitespace-pre-wrap",
  transition: true,
  guide: "ALL",
};
export const guideFull: DataColumnField = {
  ...guideDefault,
  labelUse: false,
  valueStyle: { gridColumn: "1 / span 2" },
};
export const userInfoCols: DataCols = { rgst_info: rgst_admin, edit_info: edit_admin };
export const brewingSummary = (locale: string | undefined): DataColumn[] => [
  {
    field: "brewing_summary_1",
    fieldId: {
      brewing_term: { ...secondTimer(locale), prev: { element: "brewing_step_time", transition: true }, unitPrev: " - " },
      brewing_type: { ...select, prev: { element: "brewing_type", transition: true }, unitPrev: " - ", codeGroup: "EXTR" },
      brewing_bar: { ...bar, prev: { element: "brewing_bar", transition: true }, unitPrev: " : " },
      brewing_temp: { ...temp, prev: { element: "brewing_temp", transition: true }, unitPrev: " : " },
      brewing_satis: { ...number, prev: { element: "brewing_satis", transition: true }, unitPrev: " : " },
      blending_loss: { ...percent, prev: { element: "loss_rate", transition: true }, unitPrev: " : " },
    },
    valueJoin: " | ",
  },
  {
    field: "brewing_default_memo",
    prev: { element: "brewing_default_memo", transition: true },
    unitPrev: " : ",
    itemClassName: "whitespace-pre-wrap text-start",
  },
];
export const timelineDefs = [
  {
    colors: [
      { color: "inherit", offset: 0, opacity: 0.2 },
      { color: "inherit", offset: 45, opacity: 0 },
    ],
    id: "clear",
    type: "linearGradient",
  },
  {
    colors: [
      { color: "inherit", offset: 0, opacity: 0.5 },
      { color: "inherit", offset: 55, opacity: 0 },
    ],
    id: "half",
    type: "linearGradient",
  },
  {
    colors: [
      { color: "inherit", offset: 0, opacity: 0.7 },
      { color: "inherit", offset: 70, opacity: 0 },
    ],
    id: "fill",
    type: "linearGradient",
  },
  {
    colors: [
      { color: "inherit", offset: 0, opacity: 1 },
      { color: "inherit", offset: 100, opacity: 0.3 },
    ],
    id: "full",
    type: "linearGradient",
  },
];
export type LineDatum = {
  x: string | number | Date | null;
  y: number | null;
};

export type TimeLineSeries = {
  id: string | number;
  data: LineDatum[];
  title?: string | undefined;
  compare?: string;
};

export const timelineFill = (
  fillArr: Partial<Record<"fill" | "full" | "half", string[]>>,
): {
  id: string;
  match: Record<string, unknown> | "*" | SvgFillMatcher<any>;
}[] => {
  return [
    { id: "full", match: (d: TimeLineSeries) => (fillArr.full ?? []).includes(d.id as string) },
    { id: "fill", match: (d: TimeLineSeries) => (fillArr.fill ?? []).includes(d.id as string) },
    { id: "half", match: (d: TimeLineSeries) => (fillArr.half ?? []).includes(d.id as string) },
    { id: "clear", match: (d: TimeLineSeries) => !Object.values(fillArr).every((item) => (item ?? []).includes(d.id as string)) },
  ];
};
export const alertLoading: AlertProps = {
  open: true,
  loading: true,
};
export const alertClose: AlertProps = {
  open: false,
  loading: false,
};
export const alertOffline = (ta: TransitionType): AlertProps => {
  return {
    open: true,
    title: ta("error"),
    description: ta("offline_text"),
    useCancel: false,
    useOk: true,
    okFunction: () => {},
  };
};

export const defaultTimelineData: TimeLineSeries[] = [
  {
    data: [{ x: new Date(0), y: 100 }],
    id: "",
  },
];

export const chartCoverDivstyle: CSSProperties = {
  backgroundColor: "var(--color-background)",
  color: "inherit",
  fontSize: "inherit",
  borderRadius: "2px",
  boxShadow: "rgba(0, 0, 0, 0.25) 0px 1px 2px",
  padding: "5px 9px",
};
export const clearTimelineData: Record<string, any> = {
  pre_heating_start_term: undefined,
  pre_heating_start_bean: undefined,
  pre_heating_start_air: undefined,
  pre_heating_end_term: undefined,
  pre_heating_end_bean: undefined,
  pre_heating_end_air: undefined,
  roasting_start_bean: undefined,
  roasting_start_air: undefined,
  roasting_turning_term: undefined,
  roasting_turning_bean: undefined,
  roasting_turning_air: undefined,
  roasting_dried_term: undefined,
  roasting_dried_bean: undefined,
  roasting_dried_air: undefined,
  roasting_first_start_term: undefined,
  roasting_first_start_bean: undefined,
  roasting_first_start_air: undefined,
  roasting_first_end_term: undefined,
  roasting_first_end_bean: undefined,
  roasting_first_end_air: undefined,
  roasting_second_start_term: undefined,
  roasting_second_start_bean: undefined,
  roasting_second_start_air: undefined,
  roasting_second_end_term: undefined,
  roasting_second_end_bean: undefined,
  roasting_second_end_air: undefined,
  roasting_end_term: undefined,
  roasting_end_bean: undefined,
  roasting_end_air: undefined,
  roasting_chart_log: undefined,
  roasting_check1_term: undefined,
  roasting_check1_bean: undefined,
  roasting_check1_air: undefined,
  roasting_check2_term: undefined,
  roasting_check2_bean: undefined,
  roasting_check2_air: undefined,
  roasting_check3_term: undefined,
  roasting_check3_bean: undefined,
  roasting_check3_air: undefined,
  roasting_check4_term: undefined,
  roasting_check4_bean: undefined,
  roasting_check4_air: undefined,
  roasting_check5_term: undefined,
  roasting_check5_bean: undefined,
  roasting_check5_air: undefined,
  roasting_check6_term: undefined,
  roasting_check6_bean: undefined,
  roasting_check6_air: undefined,
  roasting_check7_term: undefined,
  roasting_check7_bean: undefined,
  roasting_check7_air: undefined,
  roasting_check8_term: undefined,
  roasting_check8_bean: undefined,
  roasting_check8_air: undefined,
  roasting_check9_term: undefined,
  roasting_check9_bean: undefined,
  roasting_check9_air: undefined,
  roasting_check10_term: undefined,
  roasting_check10_bean: undefined,
  roasting_check10_air: undefined,
};

export const tempTimelineData = {
  ...clearTimelineData,
  pre_heating_start_term: -180000,
  pre_heating_start_bean: 2300,
  pre_heating_start_air: 2300,
  pre_heating_end_term: -90000,
  pre_heating_end_bean: 21000,
  pre_heating_end_air: 21000,
  roasting_start_bean: 18590,
  roasting_start_air: 19350,
  roasting_turning_term: 65000,
  roasting_turning_bean: 12090,
  roasting_turning_air: 16300,
  roasting_dried_term: 210000,
  roasting_dried_bean: 15000,
  roasting_dried_air: 18500,
  roasting_first_start_term: 480000,
  roasting_first_start_bean: 20340,
  roasting_first_start_air: 22500,
  roasting_first_end_term: 540000,
  roasting_first_end_bean: 20840,
  roasting_first_end_air: 22800,
  roasting_end_term: 570000,
  roasting_end_bean: 20950,
  roasting_end_air: 22900,
  roasting_check1_term: 100000,
  roasting_check1_bean: 12600,
  roasting_check1_air: 16500,
  roasting_check2_term: 150000,
  roasting_check2_bean: 13500,
  roasting_check2_air: 17200,
  roasting_check3_term: 290000,
  roasting_check3_bean: 17200,
  roasting_check3_air: 20130,
  roasting_check4_term: 370000,
  roasting_check4_bean: 19000,
  roasting_check4_air: 21500,
};

export const tempSettingData = {
  setting_name_select: 5,
  setting_result_type: "DRP",
  setting_bean_type: 3,
  setting_grinder_name: 3,
  setting_machine: 3,
  setting_bean_seq: 31,
  setting_bean_mass: 200,
  setting_grinder_size: 95,
  setting_result_mass: 2000,
  setting_temp: 9200,
  //setting_start_mass: 0,
  step_detail: true,
  setting_step1_term: 0,
  setting_step1_mass: 300,
  setting_step2_term: 30000,
  setting_step2_mass: 700,
  setting_step3_term: 60000,
  setting_step3_mass: 700,
  setting_step4_term: 90000,
  setting_step4_mass: 700,
  setting_result_term: 120000,
  setting_rate: 8,
  setting_rate_detail: true,
  balance: 7,
  aroma: 8,
  sweetness: 8,
  body: 7,
  flavor: 8,
  acidity: 9,
};
export const tempBrewingData = {
  brewing_bean_mass: 200,
  brewing_temp: 9200,
  brewing_mass: 2000,
  brewing_step_use: 1,
  brewing_step1_term: 0,
  brewing_step1_mass: 300,
  brewing_step2_term: 30000,
  brewing_step2_mass: 700,
  brewing_step3_term: 80000,
  brewing_step3_mass: 700,
  brewing_step4_term: 130000,
  brewing_step4_mass: 700,
  brewing_term: 180000,
};
export const tempBrewingClearDataFields = [
  "brewing_bean_mass",
  "brewing_grinder_point",
  "brewing_mass",
  "brewing_temp",
  "brewing_bar",
  "brewing_start_time",
  "brewing_start_mass",
  "brewing_step1_term",
  "brewing_step1_mass",
  "brewing_step1_bar",
  "brewing_step1_flux",
  "brewing_step2_term",
  "brewing_step2_mass",
  "brewing_step2_bar",
  "brewing_step2_flux",
  "brewing_step3_term",
  "brewing_step3_mass",
  "brewing_step3_bar",
  "brewing_step3_flux",
  "brewing_step4_term",
  "brewing_step4_mass",
  "brewing_step4_bar",
  "brewing_step4_flux",
  "brewing_step5_term",
  "brewing_step5_mass",
  "brewing_step5_bar",
  "brewing_step5_flux",
  "brewing_step6_term",
  "brewing_step6_mass",
  "brewing_step6_bar",
  "brewing_step6_flux",
  "brewing_step7_term",
  "brewing_step7_mass",
  "brewing_step7_bar",
  "brewing_step7_flux",
  "brewing_step8_term",
  "brewing_step8_mass",
  "brewing_step8_bar",
  "brewing_step8_flux",
  "brewing_step9_term",
  "brewing_step9_mass",
  "brewing_step9_bar",
  "brewing_step9_flux",
  "brewing_step_end_term",
  "brewing_step_end_calc",
  "brewing_step_end_mass",
  "brewing_step_end_split",
  "brewing_term",
];
const tempSunburstDataCheck = false;
export const tempSunburstData = {
  name: "FLVR",
  children: [
    {
      id: "FLRLBS",
      name: "FLRLBS",
      label: "꽃향",
      subLabel: "FLORAL",
      color: "#da0d68",
      check: tempSunburstDataCheck,
      subCheck: false,
      level: 1,
      loc: 1,
    },
    {
      id: "FRT",
      name: "FRT",
      label: "과일같은",
      subLabel: "FRUITY",
      color: "#da1d23",
      check: tempSunburstDataCheck,
      subCheck: false,
      level: 1,
      loc: 1,
    },
    {
      id: "SRFRMNTD",
      name: "SRFRMNTD",
      label: "신맛/발효된",
      subLabel: "SOUR/FERMENTED",
      color: "#ebb40e",
      check: tempSunburstDataCheck,
      subCheck: false,
      level: 1,
      loc: 1,
    },
    {
      id: "GRNVGTVBS",
      name: "GRNVGTVBS",
      label: "녹색 채소 같은",
      subLabel: "GREEN/VEGETATIVE",
      color: "#1a7a2f",
      check: tempSunburstDataCheck,
      subCheck: false,
      level: 1,
      loc: 1,
    },
    {
      id: "OTHR",
      name: "OTHR",
      label: "기타",
      subLabel: "OHTER",
      color: "#0fa3b5",
      check: tempSunburstDataCheck,
      subCheck: false,
      level: 1,
      loc: 1,
    },
    {
      id: "RSTD",
      name: "RSTD",
      label: "구운",
      subLabel: "ROASTED",
      color: "#c94930",
      check: tempSunburstDataCheck,
      subCheck: false,
      level: 1,
      loc: 1,
    },
    {
      id: "SPCS",
      name: "SPCS",
      label: "향신료",
      subLabel: "SPICES",
      color: "#ad213e",
      check: tempSunburstDataCheck,
      subCheck: false,
      level: 1,
      loc: 1,
    },
    {
      id: "NTCA",
      name: "NTCA",
      label: "견과류/코코아",
      subLabel: "NUTTY/COCOA",
      color: "#a87b64",
      check: tempSunburstDataCheck,
      subCheck: false,
      level: 1,
      loc: 1,
    },
    {
      id: "SWT",
      name: "SWT",
      label: "달콤한",
      subLabel: "SWEET",
      color: "#e65832",
      check: tempSunburstDataCheck,
      subCheck: false,
      level: 1,
      loc: 1,
    },
  ],
};
export const tempPublicStage = {
  public_stage_roaster: "ALL",
  public_stage_cafe: "DTL",
  public_stage_customer: "NRML",
  public_stage_normal: "NRML",
};
